import { render } from "./filtrosStatusTrocaComponent.vue?vue&type=template&id=268e682f&scoped=true"
import script from "./filtrosStatusTrocaComponent.vue?vue&type=script&lang=js"
export * from "./filtrosStatusTrocaComponent.vue?vue&type=script&lang=js"

import "./filtrosStatusTrocaComponent.vue?vue&type=style&index=0&id=268e682f&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268e682f"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QSelect,QField});
